export default "__VITE_ASSET__BeAHxC2N__"